export class ItemSearchQuery {
  public queryParams: IItemData = {
    view: "search",
  };

  public addItemIds(value?: number[] | number) {
    // checks if value is not empty
    if (!value) {
      return;
    }
    // check if array exists on queryParams
    if (!Array.isArray(this.queryParams.itemIds)) {
      this.queryParams.itemIds = [];
    }
    // adds itemId(s) to array
    Array.isArray(value)
      ? (this.queryParams.itemIds = this.queryParams.itemIds.concat(value))
      : this.queryParams.itemIds.push(value);
  }

  public setLimit(value: number | undefined) {
    this.queryParams.limit = value;
  }

  public setOffset(value: number | undefined) {
    this.queryParams.offset = value;
  }

  public setCurrencyCode(value: string | undefined) {
    this.queryParams.currencyCode = value;
  }

  public setCustomerId(value: number | undefined) {
    this.queryParams.customerId = value;
  }

  public setCustomerGroupId(value: number | undefined) {
    this.queryParams.customerGroupId = value;
  }

  public setPromotionId(value: number | undefined) {
    this.queryParams.promotionId = value;
  }

  public setCategoryId(value: number | undefined) {
    this.queryParams.categoryId = value;
  }

  public setOtherFields(data: IQueryData) {
    Object.keys(data)
      .filter((queryKey) => !properties.includes(queryKey))
      .forEach((queryKey) => {
        if (data[queryKey]) {
          this.queryParams[queryKey] = data[queryKey];
        }
      });
  }

  public getQueryString(): string {
    const p = new URLSearchParams();
    Object.keys(this.queryParams).forEach((qp) => {
      if (this.queryParams[qp]) {
        p.append(qp, this.queryParams[qp].toString());
      }
    });

    return p.toString();
  }
}

const properties = [
  "view",
  "itemIds",
  "limit",
  "offset",
  "currencyCode",
  "promotionId",
  "categoryId",
  "customerId",
  "customerGroupId",
];

export type ProductListOrderBy = undefined | "rank" | "price" | "newest" | "innofind" | "percentageDiscount";
export type ProductListOrder = undefined | "asc" | "desc";

export interface IQueryData {
  itemIds?: number[] | number;
  limit?: number;
  offset?: number;
  currencyCode?: string;
  promotionId?: number;
  categoryId?: number;
  orderBy?: ProductListOrderBy;
  order?: ProductListOrder;
  customerId?: number;
  customerGroupId?: number;
  [key: string]: any;
}

interface IItemData extends IQueryData {
  view: string;
  itemIds?: number[];
}
